<template>
  <div class="service">
    <h2 class="text__center">Services</h2>
    <ServiceFilters :types="getRequestTypes" />
    <div class="service--actions flex__right">
      <button class="btn btn__small btn__green services--new" @click="setNewToggled">New Service</button>
    </div>
    <NewService :toggled="newToggled" :types="getRequestTypes" @setNewToggled="setNewToggled" />
    <DeleteService
      :toggled="deleteToggled"
      :service="deleteService"
      @toggleDelete="setDeleteToggled"
      @clearDeleteService="clearDeleteService"
    />
    <div class="tile-group">
      <Service
        v-for="service in getFilteredServices"
        :key="service._id"
        :service="service"
        :types="getRequestTypes"
        @toggleDelete="setDeleteToggled"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ServiceFilters from "./ServiceFilters";
import NewService from "./NewService";
import DeleteService from "./DeleteService";
import Service from "./Service";
export default {
  data() {
    return {
      newToggled: false,
      deleteToggled: false,
      deleteService: null
    };
  },
  components: {
    ServiceFilters,
    NewService,
    DeleteService,
    Service
  },
  computed: {
    ...mapGetters(["getRequestTypes", "getFilteredServices"])
  },
  methods: {
    setNewToggled() {
      return (this.newToggled = !this.newToggled);
    },
    setDeleteToggled(service) {
      this.deleteService = service;
      return (this.deleteToggled = !this.deleteToggled);
    },
    clearDeleteService() {
      this.deleteService = null;
      this.deleteToggled = !this.deleteToggled;
    }
  }
};
</script>

<style scoped lang="scss">
</style>